import React from 'react';
import { CheckIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { offerBonuses, offerTrust, offerVolumes } from '../../data/content';
import { MOCKUP_IMAGE } from '../../data/links';
export function Offer() {
  return <section id="offer" className="bg-teal px-3 py-14 md:px-5 md:py-20" data-id="element-214" data-mp="3549hklq2xrhd">
      <div className="mx-auto max-w-2xl" data-id="element-215" data-mp="3a4xflrcq78l3">
        <div className="px-2 text-center text-white" data-id="element-216" data-mp="3f4js1ykqcksu">
          <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-gold-light" data-id="element-217" data-mp="3f2yx47ui6zug">Today&apos;s Digital Access Offer</p>
          <h2 className="mt-2 text-[26px] font-extrabold leading-[1.18] md:text-4xl" data-id="element-218" data-mp="3jxmdfjfcsnxy">
            Your Complete Postoperative Wound Assessment Toolkit
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border-4 border-gold bg-white shadow-2xl" data-id="element-219" data-mp="3sxrjnq8t9gaj">
          <div className="bg-navy px-4 py-3 text-center text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-220" data-mp="1pwwhmvgra9i">
            Postoperative Wound Complications Blueprint™
          </div>

          <div className="p-5 md:p-8" data-id="element-221" data-mp="1fku0rb13jzb6">
            <img src={MOCKUP_IMAGE} alt="All 11 resources included in the blueprint" className="mx-auto w-full" data-id="element-222" data-mp="1bks97up2sm9m" />

            <div className="mt-6 grid gap-6 sm:grid-cols-2" data-id="element-223" data-mp="16m8jdj7d2qbz">
              <div data-id="element-224" data-mp="16ns35js87jii">
                <p className="text-sm font-extrabold uppercase tracking-wide text-teal" data-id="element-225" data-mp="23by8ya0vwhyd">6 Practical Volumes</p>
                <ul className="mt-3 space-y-2" data-id="element-226" data-mp="1z9um6p8rlqxs">
                  {offerVolumes.map(v => <li key={v} className="flex items-start gap-2 text-[15px] font-semibold leading-snug text-navy" data-id="element-227" data-mp="1ujeab9kleddj">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-228" data-mp="1plcq2lbfk80h" />
                      {v}
                    </li>)}
                </ul>
              </div>
              <div data-id="element-229" data-mp="2i7nq9uv4k6wr">
                <p className="text-sm font-extrabold uppercase tracking-wide text-teal" data-id="element-230" data-mp="2i75ka6inuebn">Plus 5 Actionable Bonuses</p>
                <ul className="mt-3 space-y-2" data-id="element-231" data-mp="364kbvwsw4056">
                  {offerBonuses.map(b => <li key={b} className="flex items-start gap-2 text-[15px] font-semibold leading-snug text-navy" data-id="element-232" data-mp="366epeq1u0pz8">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-233" data-mp="2weiol78d2lrb" />
                      {b}
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="mt-8 border-t border-dashed border-navy/20 pt-6 text-center" data-id="element-234" data-mp="2nfnh7rtkz5mf">
              <p className="text-sm font-extrabold uppercase tracking-wide text-navy/60" data-id="element-235" data-mp="29fmfyb9elw6f">Complete Package</p>
              <p className="mt-1 flex items-start justify-center gap-1 font-extrabold text-navy" data-id="element-236" data-mp="2dgepz6q3o53r">
                <span className="mt-3 text-lg" data-id="element-237" data-mp="7ng3ij0nkur6">ONLY</span>
                <span className="text-[72px] leading-none tracking-tight text-cta-dark md:text-[88px]" data-id="element-238" data-mp="bp1n0n7p07ac">$27</span>
                <span className="mt-3 text-lg" data-id="element-239" data-mp="1w5sqorfcvqbb">USD</span>
              </p>
              <p className="mt-2 text-sm font-bold text-navy" data-id="element-240" data-mp="1s58sdkj1qgnl">One-Time Payment. No Subscription.</p>
              <p className="mx-auto mt-3 flex max-w-sm items-center justify-center gap-2 rounded-full bg-teal-light px-4 py-2 text-xs font-semibold text-teal-dark" data-id="element-241" data-mp="25w3t29je5rg3">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-242" data-mp="214c94huqqjyx" />
                Price converts to your local currency automatically
              </p>
            </div>

            <div className="mt-6" data-id="element-243" data-mp="2auowsixuqt9a">
              <ScarcityBar data-id="element-244" data-mp="2axt3po2pc33n" />
            </div>

            <div className="mt-6" data-id="element-245" data-mp="2ou6ph9e9qqnx">
              <CTAButton label="Yes! I Want It — $27" sublabel="Give me the complete wound assessment blueprint" data-id="element-246" data-mp="2ot5box5vbq2i" />
            </div>

            <Countdown data-id="element-247" data-mp="ugyn8wnyrcs9" />

            <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-248" data-mp="ui9sl0x24slh">
              {offerTrust.map(t => <li key={t} className="flex items-start gap-2 text-[13px] font-semibold leading-snug text-navy/80" data-id="element-249" data-mp="pj6ygbim86sa">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-250" data-mp="rw925ahix1yq" />
                  {t}
                </li>)}
            </ul>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-semibold text-navy/60" data-id="element-251" data-mp="10yico0cskvc4">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-252" data-mp="15v8tipwf7uyl" />
              Secure, encrypted checkout
            </p>
          </div>
        </div>
      </div>
    </section>;
}